import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
    private socket!: Socket;
    public connectionStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  
    constructor(protected http: HttpClient) {
      this.initiateSocket();
    }
  
    initiateSocket(): void {
      this.socket = io(environment.apiSocketUrl, { transports: ['websocket'] });
  
      this.socket.on('connect', () => {
        console.log('Connected');
        this.connectionStatus.next(true);
      });
  
      this.socket.on('disconnect', (reason) => {
        console.log('Socket disconnected due to:', reason);
        this.connectionStatus.next(false);
      });
  
      this.socket.on('connect_error', (error) => {
        console.log('Socket connection error:', error);
        this.connectionStatus.next(false);
      });
  
      this.socket.on('connect_timeout', () => {
        console.log('Socket connection timeout');
        this.connectionStatus.next(false);
      });
  
      this.socket.on('error', (error) => {
        console.log('Socket error:', error);
        this.connectionStatus.next(false);
      });
    }
  }